



































import Vue from "vue";
import ProductCard from "../components/ProductCard.vue";

export default Vue.extend({
  metaInfo: {
    title: "Home",
    meta: [
      { charset: 'utf-8' },
      { name: 'description', content: "Educabinh helps you simplify the teaching work, making them more interesting" }
    ]
  },
  components: {
    ProductCard,
  },
  methods: {
    goToLessonb() {
      this.$router.push("/product/lessonb");
    },
    goToScoredent() {
      this.$router.push("/product/scoredent");
    },
  }
});
